<template>
  <div id="app">
    <main-header></main-header>
    <router-view/>
    <main-footer></main-footer>
  </div>
</template>

<script>
import mainHeader from '@/components/header.vue'
import mainFooter from '@/components/footer.vue'

export default {
  name: 'Home',
  components: {
    mainHeader,
    mainFooter
  }
}
</script>


<style lang="scss">
@import 'assets/scss/common';
body {
  position: relative;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #222;
}
</style>
